import {$, cnpj, cpfOrCnpj, datetime, InputType, Schema} from 'simpli-web-sdk'
import ConfigNovaSla from '@/model/resource/ConfigNovaSla'

export default (model: ConfigNovaSla): Schema => ({
  cnpjEmbarcador: {
    content: cpfOrCnpj(model.cnpjEmbarcador) || '',
  },
  cnpjTransportador: {
    content: cpfOrCnpj(model.cnpjTransportador) || '',
  },
  ufOrigem: {
    content: model.ufOrigem,
  },
  cidadeOrigem: {
    content: model.cidadeOrigem,
  },
  ufDestino: {
    content: model.ufDestino,
  },
  cidadeDestino: {
    content: model.cidadeDestino,
  },
  sla: {
    content: model.sla || '0',
  },
  calendarizacao: {
    content: model.calendarizacaoString || '',
  },
  nomeTipoVeiculo: {
    content:  model.nomeTipoVeiculo,
  },
  funcionamento: {
    content: model.funcionamento
  }
})
